.area {
	flex: unset;
}
